<div class="mt-8 flex flex-col items-center">
  <div class="tk-c-gray">{{'labels.vehicle' | translate | titlecase}}</div>
  <div class="mt-1 font-bold text-2xl">{{model?.vehicleName}}</div>
  <div class="mt-2 tk-c-gray">
    <span class="mr-1">{{'labels.mileage' | translate}}:</span>
    <span *ngIf="model?.mileage else noDataTemp" class="font-semibold">{{model?.mileage}} {{'measure-unit.kilometers-short' | translate}}</span>
    <span class="ml-2 mr-1">{{'labels.fuel' | translate | titlecase}}:</span>
    <span *ngIf="model?.fuel else noDataTemp" class="font-semibold">{{model?.fuel}}</span>
  </div>
  <div class="mt-2 w-5 h-5" [ngClass]="{'tk-i-arrow-blue-down': model?.isGiven, 'tk-i-arrow-up-blue': !model?.isGiven}"></div>
  <div class="mt-1 tk-c-gray">{{fromOrToDriverTrans}}</div>
  <div class="mt-1 font-bold text-sm">{{model?.driverFullName}}</div>
  <div class="mt-1 tk-c-gray">
    {{'handover.id-number' | translate}}
    <span class="font-semibold mx-1"><span *ngIf="model?.workerIdNumber else noDataTemp">{{model?.workerIdNumber}}</span></span>
    {{'contact.phone-prefix' | translate | titlecase}}:
    <span class="font-semibold mx-1"><span *ngIf="model?.phone else noDataTemp">{{model?.phone}}</span></span>
  </div>
</div>

<ng-template #noDataTemp>
  {{'labels.none' | translate}}
</ng-template>
